import {
    LOAD_VALUE_LIST,
    LOAD_VALUE_LIST_SUCCESS,
    LOAD_VALUE_LIST_ERROR,
    CLEAR_VALUE_LIST,
    CLEAR,
} from 'constants/ActionTypes';
import Context from 'managers/Context';

let defaultState;

function initState() {
    if (!defaultState) {
        defaultState = {};
        const initialStateCache = Context.cacheManager.getValueListDefaultStore();
        if (initialStateCache) {
            Object.keys(initialStateCache).forEach((element) => {
                let data = initialStateCache[element];
                data = data instanceof Array ? [...data] : [data];
                defaultState[element] = {
                    loading: false,
                    error: false,
                    show: true,
                    data,
                    tries: 0,
                };
            });
        }
    }
    return defaultState;
}

export default function config(state = initState(), action) {
    let nextState = state;
    const valueList = state[action.valueList];
    if (!valueList && action.valueList) {
        nextState = {
            ...state,
            [action.valueList]: {
                loading: false,
                error: false,
                show: false,
                data: [],
                tries: 0,
            },
        };
    }

    const tries = valueList ? valueList.tries || 0 : 0;

    switch (action.type) {
        case LOAD_VALUE_LIST:
            return {
                ...nextState,
                [action.valueList]: {
                    loading: true,
                    error: false,
                    show: true,
                    data: [],
                    tries,
                },
            };

        case LOAD_VALUE_LIST_SUCCESS:
            return {
                ...nextState,
                [action.valueList]: {
                    loading: false,
                    error: false,
                    data: action.result instanceof Array ? [...action.result] : [action.result],
                    show: true,
                    tries: tries + 1,
                },
            };
        case LOAD_VALUE_LIST_ERROR:
            return {
                ...nextState,
                [action.valueList]: {
                    loading: false,
                    error: true,
                    show: true,
                    data: [],
                    tries: tries + 1,
                },
            };
        case CLEAR:
        case CLEAR_VALUE_LIST:
            return {};
        default:
            return state;
    }
}
